/* eslint-disable import/prefer-default-export */
/**
 * Максимальный размер файла в байтах
 * 20971520 - 20 Мегабайт
 */
export const maxFileInputSize = 20971520;
